import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles<{ active: boolean }>()((theme, { active }) => ({
  activeMarker: {
    display: active ? 'block' : 'none',
    position: 'absolute',
    top: theme.spacing(0.4),
    right: theme.spacing(0.4),
    width: '10px',
    height: '10px',
    backgroundColor: theme.palette.primary.main,
    borderRadius: '50%',
  },
}));
export default useStyles;
